import { camelCase } from 'lodash';
import { useMemo } from 'react';

export function useCamelCase(text?: string) {
  return useMemo(() => camelCase(text || ''), [text]);
}
